/**
 * UI Library Components Test
 *
 * This component is used to verify that the @randompedestrian07/ui library
 * can be imported and used correctly in the new_discord_bots front-end.
 *
 * This is a temporary test component that can be removed once Phase 1 is complete.
 */

import { Button, Card, Badge, Alert, AlertTitle, AlertDescription, Input } from '@randompedestrian07/ui';

export const UIComponentsTest = () => {
  return (
    <div className="p-8 space-y-6">
      <h1 className="text-2xl font-bold text-white mb-4">
        UI Library Components Test
      </h1>

      {/* Button Test */}
      <Card className="p-4">
        <h2 className="text-lg font-semibold mb-3">Button Component</h2>
        <div className="flex gap-3 flex-wrap">
          <Button variant="default">Default Button</Button>
          <Button variant="secondary">Secondary Button</Button>
          <Button variant="destructive">Destructive Button</Button>
          <Button variant="outline">Outline Button</Button>
          <Button variant="ghost">Ghost Button</Button>
        </div>
      </Card>

      {/* Input Test */}
      <Card className="p-4">
        <h2 className="text-lg font-semibold mb-3">Input Component</h2>
        <div className="space-y-3">
          <Input placeholder="Default input" />
          <Input placeholder="Disabled input" disabled />
        </div>
      </Card>

      {/* Badge Test */}
      <Card className="p-4">
        <h2 className="text-lg font-semibold mb-3">Badge Component</h2>
        <div className="flex gap-3 flex-wrap">
          <Badge variant="default">Default</Badge>
          <Badge variant="secondary">Secondary</Badge>
          <Badge variant="destructive">Destructive</Badge>
          <Badge variant="outline">Outline</Badge>
        </div>
      </Card>

      {/* Alert Test */}
      <Card className="p-4">
        <h2 className="text-lg font-semibold mb-3">Alert Component</h2>
        <Alert>
          <AlertTitle>Success!</AlertTitle>
          <AlertDescription>
            UI library components are working correctly.
          </AlertDescription>
        </Alert>
      </Card>
    </div>
  );
};
